/**
 * A simple seeded random number generator.
 * LGC (Linear Congruential Generator) or similar.
 */
export default class SeededRandom {
    constructor(seed = 1) {
        this.seed = seed;
    }

    // Returns a pseudo-random float between 0 and 1
    random() {
        const x = Math.sin(this.seed++) * 10000;
        return x - Math.floor(x);
    }

    // Returns a pseudo-random float between min and max
    range(min, max) {
        return min + this.random() * (max - min);
    }
}
